class ComponentMegamenu extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.header = this.closest("component-header");
    this.triggers = Theme.querySelectorAll("[data-megamenu]", this);
    this.panels = Theme.querySelectorAll("[data-megamenu-panel]", this);

    if (this.panels.length === 0) {
      return;
    }

    this.onTriggerEnter = (event) => this.open(event.currentTarget.dataset.megamenu);
    this.onTriggerFocus = (event) => this.open(event.currentTarget.dataset.megamenu);

    this.triggers.forEach((trigger) => {
      trigger.addEventListener("mouseenter", this.onTriggerEnter);
      trigger.addEventListener("focus", this.onTriggerFocus);
    });

    this.onLeave = () => this.close();
    this.onKeydown = (event) => {
      if (event.key === "Escape") {
        this.close();
      }
    };

    this.addEventListener("mouseleave", this.onLeave);
    document.addEventListener("keydown", this.onKeydown);

    this.addDirectEvent("predictivesearch:open", document, () => this.close());
  }

  disconnectedCallback() {
    this.triggers.forEach((trigger) => {
      trigger.removeEventListener("mouseenter", this.onTriggerEnter);
      trigger.removeEventListener("focus", this.onTriggerFocus);
    });

    this.removeEventListener("mouseleave", this.onLeave);
    document.removeEventListener("keydown", this.onKeydown);

    super.disconnectedCallback();
  }

  open(index) {
    if (this.active === index) {
      return;
    }

    this.active = index;

    document.dispatchEvent(new CustomEvent("megamenu:open"));

    this.panels.forEach((panel) => {
      const open = panel.dataset.megamenuPanel === index;

      panel.classList.toggle("is-open", open);
      panel.setAttribute("aria-hidden", open ? "false" : "true");
      panel.toggleAttribute("inert", !open);
    });

    this.triggers.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", trigger.dataset.megamenu === index ? "true" : "false");
    });

    if (this.header) {
      this.header.classList.add("is-mega-open");
    }
  }

  close() {
    if (!this.active) {
      return;
    }

    this.active = null;

    this.panels.forEach((panel) => {
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
      panel.toggleAttribute("inert", true);
    });

    this.triggers.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", "false");
    });

    if (this.header) {
      this.header.classList.remove("is-mega-open");
    }
  }
}

customElements.define("component-megamenu", ComponentMegamenu);
